// @flow strict
export const DefaultLayoutSymbol: symbol = Symbol('default');
export const UniformRowLayoutSymbol: symbol = Symbol('uniformRow');
